symbolWinBorderAnim = {};
symbolWinBorderAnim.reels = 5;
symbolWinBorderAnim.row = 3;
symbolWinBorderAnim.data = [];
symbolWinBorderAnim.callback;
symbolWinBorderAnim.reactionTween = undefined;
symbolWinBorderAnim.lastReactions = [];

symbolWinBorderAnim.create = function (json) {
  return new PIXI.Container();
};

symbolWinBorderAnim.initialise = function (json, container, resources) {
  symbolWinBorderAnim.container = container;

  for (var i = 0; i < symbolWinBorderAnim.reels; i++) {
    var rowList = [];

    for (var j = 0; j < symbolWinBorderAnim.row; j++) {
      var symbol = {};
      symbol.animation = resourceManager.createObject(
        "movie",
        "symbolBorderAnim_" + i + "_" + j,
        symbolWinBorderAnim.container,
        { definition: "symbolWin", x: 0, y: 0, loop: false, scale: "0.95" }
      );
      symbol.animation.gotoAndStop(0);
      symbol.animation.visible = false;
      rowList.push(symbol);
    }
    symbolWinBorderAnim.data.push(rowList);
  }

  messageBus.subscribe(
    "spinner:GameConfigEvent",
    symbolWinBorderAnim.onLayoutComplete
  );
};

symbolWinBorderAnim.onLayoutComplete = function () {
  Reflex.registerEventHandler(
    "orientationChange",
    symbolWinBorderAnim.onOrientationChange
  );
  symbolWinBorderAnim.reactionSprites = [
    resourceManager.get("winReactionContainer:niceText"),
    resourceManager.get("winReactionContainer:neatText"),
    resourceManager.get("winReactionContainer:sweetText"),
    resourceManager.get("winReactionContainer:incredibleText"),
    resourceManager.get("winReactionContainer:astoundingText"),
    resourceManager.get("winReactionContainer:amazingText"),
    resourceManager.get("winReactionContainer:crazyText"),
    resourceManager.get("winReactionContainer:locoText"),
    resourceManager.get("winReactionContainer:omgText"),
    resourceManager.get("winReactionContainer:astonishingText"),
    resourceManager.get("winReactionContainer:unbelievableText"),
    resourceManager.get("winReactionContainer:legendaryText"),
  ];

  symbolWinBorderAnim.reactionSounds = [
    "reactionNice",
    "reactionNeat",
    "reactionSweet",
    "reactionIncredible",
    "reactionAstounding",
    "reactionAmazing",
    "reactionCrazy",
    "reactionLoco",
    "reactionOmg",
    "reactionAstonishing",
    "reactionUnbelievable",
    "reactionLegendary",
  ];
};

symbolWinBorderAnim.playAnimation = function (sequence, callback) {
  symbolWinBorderAnim.callback = callback;

  for (var i = 0; i < sequence.data.length; i++) {
    var reel = sequence.data[i].reel;
    var row = sequence.data[i].row;
    const updatedSymbolOrder = gameController.getUpdatedSymbolOrder(reel);
    const targetSymbol = resourceManager.get(
      "slotContainer:reelContainer:reel" +
        reel +
        ":symbolContainer:symbol" +
        updatedSymbolOrder[row] +
        ":symbol"
    );

    var xPos = gameController.getSymbolWorldPosition(targetSymbol).x - 94;
    var yPos = gameController.getSymbolWorldPosition(targetSymbol).y - 105;

    symbolWinBorderAnim.data[reel][row].animation.position.set(xPos, yPos);
    symbolWinBorderAnim.data[reel][row].animation.visible = true;
    symbolWinBorderAnim.data[reel][row].animation.play();
  }

  const currentMultiplier = resourceManager
    .get("lanternMultiplier:lantern")
    .getCurrentMultiplier();
  if (currentMultiplier >= 8) {
    symbolWinBorderAnim.playWinReaction(sequence, currentMultiplier);
  }

  Reflex.addToUpdate(symbolWinBorderAnim.update);
};

symbolWinBorderAnim.playWinReaction = function (sequence, currentMultiplier) {
  let topReel = 0;
  let topRow = 0;
  let lowestReel = 5;
  let lowestRow = 5;

  let reactionSprite = undefined;
  let endScale = 1;

  let index;
  // Picks reaction sprites randomly from a range.
  switch (currentMultiplier) {
    case 8:
      index = Math.floor(Math.random() * 3);
      if (this.lastReactions.includes(index)) {
        index = (index + 1) % 3;
      }
      reactionSprite = symbolWinBorderAnim.reactionSprites[index];
      soundManager.play(symbolWinBorderAnim.reactionSounds[index]);
      break;
    case 16:
      index = Math.floor(Math.random() * 3);
      if (this.lastReactions.includes(index)) {
        index = (index + 1) % 3;
      }
      reactionSprite = symbolWinBorderAnim.reactionSprites[index];
      soundManager.play(symbolWinBorderAnim.reactionSounds[index]);
      break;
    case 32:
      index = Math.floor(Math.random() * 3) + 3;
      if (this.lastReactions.includes(index)) {
        index = (index + 1) % 3;
        if (index === 0) {
          index = 3;
        }
      }
      reactionSprite = symbolWinBorderAnim.reactionSprites[index];
      soundManager.play(symbolWinBorderAnim.reactionSounds[index]);
      break;
    case 64:
      index = Math.floor(Math.random() * 3) + 3;
      if (this.lastReactions.includes(index)) {
        index = (index + 1) % 3;
        if (index === 0) {
          index = 3;
        }
      }
      reactionSprite = symbolWinBorderAnim.reactionSprites[index];
      soundManager.play(symbolWinBorderAnim.reactionSounds[index]);
      break;
    case 128:
      index = Math.floor(Math.random() * 3) + 6;
      if (this.lastReactions.includes(index)) {
        index = (index + 1) % 3;
        if (index === 0) {
          index = 6;
        }
      }
      reactionSprite = symbolWinBorderAnim.reactionSprites[index];
      soundManager.play(symbolWinBorderAnim.reactionSounds[index]);
      break;
    case 256:
      index = Math.floor(Math.random() * 3) + 6;
      if (this.lastReactions.includes(index)) {
        index = (index + 1) % 3;
        if (index === 0) {
          index = 6;
        }
      }
      reactionSprite = symbolWinBorderAnim.reactionSprites[index];
      soundManager.play(symbolWinBorderAnim.reactionSounds[index]);
      break;
    case 512:
      reactionSprite = resourceManager.get(
        "winReactionContainer:astonishingText"
      );
      soundManager.play("reactionAstonishing");
      break;
    case 1024:
      reactionSprite = resourceManager.get(
        "winReactionContainer:unbelievableText"
      );
      soundManager.play("reactionUnbelievable");
      break;
    case 2048:
      reactionSprite = resourceManager.get(
        "winReactionContainer:legendaryText"
      );
      soundManager.play("reactionLegendary");
      break;
  }

  symbolWinBorderAnim.lastReactions.push(index);
  if (symbolWinBorderAnim.lastReactions.length > 3) {
    symbolWinBorderAnim.lastReactions = [];
  }

  if (currentMultiplier > 2048) {
    reactionSprite = resourceManager.get("winReactionContainer:legendaryText");
    soundManager.play("reactionLegendary");
  }

  for (let i = 0; i < sequence.data.length; i++) {
    if (sequence.data[i].reel > topReel) {
      topReel = sequence.data[i].reel;
    }
    if (sequence.data[i].row > topRow) {
      topRow = sequence.data[i].row;
    }
    if (sequence.data[i].reel < lowestReel) {
      lowestReel = sequence.data[i].reel;
    }
    if (sequence.data[i].row < lowestRow) {
      lowestRow = sequence.data[i].row;
    }
  }

  const updatedSymbolOrder = gameController.getUpdatedSymbolOrder(0);
  const topPosition = gameController.getSymbolWorldPosition(
    resourceManager.get(
      "slotContainer:reelContainer:reel" +
        0 +
        ":symbolContainer:symbol" +
        updatedSymbolOrder[lowestRow] +
        ":symbol"
    )
  ).y;

  const bottomPosition = gameController.getSymbolWorldPosition(
    resourceManager.get(
      "slotContainer:reelContainer:reel" +
        0 +
        ":symbolContainer:symbol" +
        updatedSymbolOrder[topRow] +
        ":symbol"
    )
  ).y;

  const leftPosition = gameController.getSymbolWorldPosition(
    resourceManager.get(
      "slotContainer:reelContainer:reel" +
        lowestReel +
        ":symbolContainer:symbol" +
        0 +
        ":symbol"
    )
  ).x;

  const rightPosition = gameController.getSymbolWorldPosition(
    resourceManager.get(
      "slotContainer:reelContainer:reel" +
        topReel +
        ":symbolContainer:symbol" +
        0 +
        ":symbol"
    )
  ).x;

  const xMidPoint = (rightPosition - leftPosition) / 2;
  const yMidPoint = (bottomPosition - topPosition) / 2;
  const xPos = symbolWinBorderAnim.isLandscape()
    ? leftPosition + xMidPoint
    : 360;
  const yPos = topPosition + yMidPoint;

  reactionSprite.position.x = xPos;
  reactionSprite.position.y = yPos;

  reactionSprite.visible = true;
  reactionSprite.rotation = 0;
  gsap.to(reactionSprite, {
    duration: 0.75,
    rotation: Math.floor(Math.random() * 2) === 0 ? -0.15 : 0.15,
    yoyo: true,
  });
  symbolWinBorderAnim.reactionTween = gsap.to(reactionSprite, {
    duration: 0.5,
    pixi: { scale: endScale },
    ease: "elastic.out",
    onComplete: () => {
      gsap.to(reactionSprite, {
        duration: 0.25,
        pixi: { scale: 0 },
        onComplete: () => {
          reactionSprite.visible = false;
          reactionSprite.scale = 0.5;
        },
      });
    },
  });
};

symbolWinBorderAnim.isLandscape = function () {
  if (
    layoutController.getCurrentLayout() === "portrait_default" ||
    layoutController.getCurrentLayout == "portrait_mobile"
  ) {
    return false;
  }
  return true;
};

symbolWinBorderAnim.onOrientationChange = function () {
  if (symbolWinBorderAnim.reactionTween !== undefined) {
    symbolWinBorderAnim.reactionTween.progress(1);
    symbolWinBorderAnim.reactionTween = undefined;
  }
  for (var i = 0; i < symbolWinBorderAnim.reels; i++) {
    for (var j = 0; j < symbolWinBorderAnim.row; j++) {
      const reel = i;
      const row = j;
      const updatedSymbolOrder = gameController.getUpdatedSymbolOrder(reel);
      const targetSymbol = resourceManager.get(
        "slotContainer:reelContainer:reel" +
          reel +
          ":symbolContainer:symbol" +
          updatedSymbolOrder[row] +
          ":symbol"
      );

      var xPos = gameController.getSymbolWorldPosition(targetSymbol).x - 94;
      var yPos = gameController.getSymbolWorldPosition(targetSymbol).y - 105;

      symbolWinBorderAnim.data[reel][row].animation.position.set(xPos, yPos);
    }
  }
};

symbolWinBorderAnim.stopAllAnimations = function () {
  for (var i = 0; i < symbolWinBorderAnim.reels; i++) {
    for (var j = 0; j < symbolWinBorderAnim.row; j++) {
      symbolWinBorderAnim.data[i][j].animation.visible = false;
      symbolWinBorderAnim.data[i][j].animation.gotoAndStop(0);
    }
  }

  Reflex.removeFromUpdate(symbolWinBorderAnim.update);
  symbolWinBorderAnim.callback();
};

symbolWinBorderAnim.update = function () {
  var allAnimationsEnded = true;

  for (var reel = 0; reel < symbolWinBorderAnim.data.length; reel++) {
    for (var row = 0; row < symbolWinBorderAnim.data[reel].length; row++) {
      if (symbolWinBorderAnim.data[reel][row].animation.playing) {
        allAnimationsEnded = false;
      }
    }
  }

  if (allAnimationsEnded) {
    symbolWinBorderAnim.stopAllAnimations();
  }
};

symbolWinBorderAnim.getFilesRequired = function (json) {
  return [];
};

resourceManager.registerObjectType(
  "symbolWinBorderAnim",
  symbolWinBorderAnim.create,
  symbolWinBorderAnim.initialise,
  symbolWinBorderAnim.getFilesRequired
);
